// Vendor libraries

import { createApp } from "vue";

// Router

import router from "./router";

// Local plugins

import Helpers from "@/plugins/helpers";
import Http from "@/plugins/http";
import Notificator from "@/plugins/notificator";
import Core from "@/plugins/core";
import Form from "@/plugins/form";

// Local services
import notificator from "@/services/notificator";
import configureSentry from "@/services/sentry";

// Components
import master from "./master.vue";
import layout from "./layout.vue";

/*
|--------------------------------------------------------------------------
| Vue instance
|--------------------------------------------------------------------------
*/

const App = createApp({
  provide: () => {
    return {
      notificator: notificator
    };
  },
});

// Init Sentry
if (["staging", "production"].includes(Laravel.app.env)) {
  configureSentry(
    App,
    router,
    ["localhost:3000", process.env.MIX_APP_DOMAIN]
  );
}

App.directive("loading", {
  mounted(el, binding, vnode) {
    let loadingMask = document.createElement("div");
    loadingMask.className = "loading-mask";
    el.prepend(loadingMask);
    if (binding.value) {
      loadingMask.className += " is-active";
    }
  },
  updated(el, binding, vnode) {
    let loadingMask = el.getElementsByClassName("loading-mask")[0]; // Get the first div in the node
    if (binding.value) {
      loadingMask.className = "loading-mask is-active";
    } else {
      loadingMask.className = "loading-mask";
    }
  }
});

// Use the router
App.use(router);

// Use plugins
App.use(Helpers);
App.use(Http);
App.use(Notificator);
App.use(Core);
App.use(Form);

App.component("v-master", master);
App.component("v-layout", layout);

// Mount the dom
App.mount("#app");
